<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('containers.containers'), name: 'company_containers' },
            { text: $t('containers.addContainer') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('meta.baseData') }}</h3>
            <div class="header-meta"></div>
          </header>
          <div class="content-body">
            <form @submit.prevent="createContainer" class="form" method="post">
              <TextInputField :field="'name'" v-model="container.name" :labelTranslationKey="'meta.name'" />
              <GeoCoder :latitude="container.lat" :longitude="container.lng" @coordinates="getCoordinates" />
              <div class="form-wrap select-wrap">
                <label for="project">{{ $t('containers.project') }}</label>
                <select v-model="container.project_uuid" class="select-wrap">
                  <option v-for="project in projects" :value="project.uuid" :key="project.uuid">
                    {{ project.name }}
                  </option>
                </select>
              </div>

              <!-- FIXME Does not work if there are no areas and zones -->
              <!-- Maybe it does not work at all when creating new containers -->
              <div v-if="companyUser.company_type == 'industry'">
                <div class="form-wrap select-wrap">
                  <label for="site">{{ $t('meta.site') }}</label>
                  <select v-model="container.site_uuid" @change="getAreas" class="select-wrap">
                    <option v-for="site in sites" :value="site.uuid" :key="site.uuid">
                      {{ site.name }}
                    </option>
                  </select>
                </div>

                <div v-if="container.site_uuid" class="form-wrap select-wrap">
                  <label for="area">{{ $t('meta.area') }}</label>
                  <select v-model="container.area_uuid" @change="getZones" class="select-wrap">
                    <option v-for="area in areas" :value="area.uuid" :key="area.uuid">
                      {{ area.name }}
                    </option>
                  </select>
                </div>

                <div v-if="container.area_uuid" class="form-wrap select-wrap">
                  <label for="zone">{{ $t('meta.zone') }}</label>
                  <select v-model="container.zone_uuid" class="select-wrap">
                    <option v-for="zone in zones" :value="zone.uuid" :key="zone.uuid">
                      {{ zone.name }}
                    </option>
                  </select>
                </div>
              </div>

              <BooleanRadioField
                v-if="companyUser.company_type == 'industry'"
                v-model="container.replace_plant_area"
                :field="'replace_plant_area'"
                name="'replace_plant_area'"
              />

              <TextInputField
                field="type_name"
                v-model="container.type_name"
                labelTranslationKey="containerTypes.containerTypeName"
              />

              <TextInputField
                v-model="container.type_volume"
                field="volume"
                type="number"
                step="0.1"
                modelTranslationKey="containerTypes"
              />

              <input type="submit" :value="$t('meta.save')" class="button button-green button-100 button-round" />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav.vue'
import BooleanRadioField from '@/components/container/BooleanRadioField.vue'
import TextInputField from '@/components/container/TextInputField.vue'
import GeoCoder from '@/components/geocoder.vue'
import dateUtils from '@/components/mixins/dateUtils'

import areasApi from '@/api/areas'
import containersApi from '@/api/container'
import containerGroupsApi from '@/api/containerGroups'
import projectsApi from '@/api/projects'
import sitesApi from '@/api/sites'
import zonesApi from '@/api/zones'

export default {
  name: 'CompanyContainerNew',
  inject: ['companyUser'],
  data() {
    return {
      areas: [],
      container: {},
      container_groups: [],
      projects: [],
      sites: [],
      zones: [],
    }
  },
  components: {
    BooleanRadioField,
    BreadCrumbs,
    CompanyNav,
    GeoCoder,
    SectionHeader,
    TextInputField,
  },
  mixins: [dateUtils],
  methods: {
    async getAreas() {
      this.areas = await areasApi.getAll(this.container.site_uuid)
    },
    getCoordinates(value) {
      this.container.lat = value[1]
      this.container.lng = value[0]
    },
    async getData() {
      this.projects = await projectsApi.getAll(this.companyUser.company_uuid)
      this.sites = await sitesApi.getAllForCompany(this.companyUser.company_uuid)
      this.container.company_uuid = this.companyUser.company_uuid
    },
    async createContainer() {
      const response = await containersApi.create(this.container)
      if (response.success) {
        await this.$router.push(`/company/containers/${response.data.container.uuid}`)
      }
    },
    async getGroups() {
      const result = await containerGroupsApi.getAll({
        company_uuid: this.companyUser.company_uuid,
      })
      this.container_groups = result.containerGroups
    },
    async getZones() {
      this.zones = await zonesApi.getAllInArea(this.container.area_uuid)
    },
  },
  async mounted() {
    await Promise.all([this.getData(), this.getGroups()])
  },
}
</script>

<style lang="sass" scoped>
.missing-data
  display: inline
  position: relative

  &:hover
    .description
      display: block

  .material-icons
    cursor: help
    color: #b40000

  .description
    position: absolute
    background-color: #b40000
    top: -100%
    right: -4.25rem
    transform: translateY(-3.25rem)
    padding: 0.5rem
    color: #f9f9f9
    border-radius: 5px
    font-size: 0.75rem
    min-width: 14.625rem
    text-align: left
    white-space: pre-line
    display: none

    &::after
      content: ""
      position: absolute
      top: calc(100% - 3px)
      right: 4.375rem
      height: 0
      width: 0
      border-top: solid 15px #b40000
      border-left: solid 10px transparent
      border-right: solid 10px transparent
</style>

<style lang="sass">
.missing-data-field
  label, input
    animation: 5s ease-out highlightFont

  input
    animation: 5s ease-out highlightField

@keyframes highlightFont
  0%, 70%
    color: #b40000

  100%
    color: #91979f


@keyframes highlightField
  0%, 70%
    background-color: #b4000030
    border-color: #b40000
    border-width: 2px

  100%
    background-color: #fff
    border-color: #d7e3e6
    border-width: 1px
</style>
